import React, { useState, useEffect } from "react"
import { useFormik } from "formik"
import { Col, Form, Row } from "reactstrap"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"

import { AutoComplete } from "components/AutoComplete"
import { Button } from "components/Button"
import FormikErrorText from "components/FormikErrorText/FormikErrorText"
import { Modal } from "components/Modal"
import { MoldColorConfiguration } from "constants"
import DraggableColors from "./DraggableColors"

import { initialValues, validationSchema, FIELDS_NAME } from "./FormConfig"
import toast from "react-hot-toast"

const ChangeMouldSequenceModal = ({
   isOpen = false,
   onToggleModal = () => {},
   onSave = () => {},
   colors = [],
   isLoading = false,
}) => {
   const [selectedOption, setSelectedOption] = useState(null)
   const formik = useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: values => {
         const orderedValues = values[FIELDS_NAME.COLORS].map((c, idx) => ({
            color: c.value,
            sequence_number: idx + 1,
         }))
         onSave(orderedValues)
      },
   })

   useEffect(() => {
      formik.setValues({
         ...formik.values,
         [FIELDS_NAME.COLORS]: colors,
      })
   }, [])

   const colorOptions = Object.entries(MoldColorConfiguration).map(
      ([value, label]) => {
         return {
            value,
            label: MoldColorConfiguration.getDisplayTextKey(label),
            color: label,
         }
      }
   )
   // .filter(item => !colors.includes(item.value))

   const handleAutoComplete = option => {
      if (option) {
         formik.setFieldValue(FIELDS_NAME.COLORS, [
            ...formik.values[FIELDS_NAME.COLORS],
            option,
         ])
      }
      toast.success(`${option.label} color added to sequence`)
      setSelectedOption(null)
   }

   return (
      <Modal
         isOpen={isOpen}
         customButton={true}
         handleModalToggling={onToggleModal}
         hideModalHeaderSeparator={true}
         headerClasses="header-container justify-content-center mb-0 pt-3"
         sizeClasses="2"
         backdrop="static"
         className="color-selector-modal"
      >
         <h1 className="pt-2 pb-3 text-center">Set Sequence</h1>
         <div className="p-3">
            <Row>
               <Col xs={12}>
                  <Form onSubmit={formik.handleSubmit}>
                     <Row className="mb-3 align-items-center">
                        <label className="col-md-3 col-form-label clr-theme-primary">
                           Colors
                        </label>
                        <div className="col-md-9">
                           <AutoComplete
                              isMulti={false}
                              // options={colorOptions.filter(
                              //    option =>
                              //       !formik.values[FIELDS_NAME.COLORS].some(
                              //          c => c.value === option.value
                              //       )
                              // )}
                              options={colorOptions}
                              value={selectedOption}
                              // onChange={option => {
                              //    if (
                              //       option &&
                              //       !formik.values[FIELDS_NAME.COLORS].some(
                              //          c => c.value === option.value
                              //       )
                              //    ) {
                              //       formik.setFieldValue(FIELDS_NAME.COLORS, [
                              //          ...formik.values[FIELDS_NAME.COLORS],
                              //          option,
                              //       ])
                              //    }
                              //    setSelectedOption(null)
                              // }}

                              onChange={handleAutoComplete}
                              name={FIELDS_NAME.COLORS}
                              placeholder="Select colors"
                              closeMenuOnSelect={false}
                              className="w-100"
                              formatOptionLabel={(option, { context }) => (
                                 <div className="mould-option">
                                    <div
                                       className={`mould-color-${option?.value?.toLowerCase()}`}
                                    />
                                    <p> {option.label} </p>
                                 </div>
                              )}
                           />
                           <FormikErrorText
                              formikInstance={formik}
                              fieldName={FIELDS_NAME.COLORS}
                           />
                        </div>
                     </Row>

                     <Row className="mb-3 align-items-center">
                        <label className="col-md-3 clr-theme-primary col-form-label">
                           Selected Colors
                        </label>
                        <div className="col-md-9 color-selector-conatiner">
                           <DndProvider backend={HTML5Backend}>
                              <div className="selected-colors-container mt-3">
                                 {formik.values[FIELDS_NAME.COLORS].length ===
                                 0 ? (
                                    <div className="no-color-label text-muted">
                                       No color selected
                                    </div>
                                 ) : (
                                    formik.values[FIELDS_NAME.COLORS].map(
                                       (color, index) => (
                                          <DraggableColors
                                             key={color.value + index}
                                             index={index}
                                             color={color}
                                             moveColor={(from, to) => {
                                                const updated = [
                                                   ...formik.values[
                                                      FIELDS_NAME.COLORS
                                                   ],
                                                ]
                                                const [moved] = updated.splice(
                                                   from,
                                                   1
                                                )
                                                updated.splice(to, 0, moved)
                                                formik.setFieldValue(
                                                   FIELDS_NAME.COLORS,
                                                   updated
                                                )
                                             }}
                                             removeColor={indexToRemove => {
                                                const updated = [
                                                   ...formik.values[
                                                      FIELDS_NAME.COLORS
                                                   ],
                                                ].filter(
                                                   (_, i) => i !== indexToRemove
                                                )
                                                formik.setFieldValue(
                                                   FIELDS_NAME.COLORS,
                                                   updated
                                                )
                                             }}
                                          />
                                       )
                                    )
                                 )}
                              </div>
                           </DndProvider>
                        </div>
                     </Row>

                     <div className="d-flex justify-content-center mt-4">
                        <Button
                           type="submit"
                           isLoading={isLoading}
                           title="Save Sequence"
                           className="header-button"
                        />
                     </div>
                  </Form>
               </Col>
            </Row>
         </div>
      </Modal>
   )
}

export default ChangeMouldSequenceModal
